<mf-page title="Nueva plantilla genérica">
  <mf-template
    [templateDto]="templateGenericDto"
    (save)="save($event)"
    (closeButtonClick)="close()" />
</mf-page>
